<template>
    <AppButton
        variant="blue"
        class="ml-2"
        :class="isDesktop.screenSize.value == 'xs' ? '!hidden' : ''"
        @button-click="emit('addBoard')"
        icon-type="far"
        prefix-icon="plus"
        btn-text="Board"
    />
</template>

<script setup>
// Vue imports
import { computed, ref, onUpdated, watch } from 'vue';

// Vue router imports
import { useRoute, useRouter } from 'vue-router';

// I18n imports
import { useI18n } from 'vue-i18n';

// Components imports
import AppButton from '@/components/appComponents/AppButton.vue';
import { useHeaderStore } from '@/stores/headerStore.js';

const headerStore = useHeaderStore();

const emit = defineEmits(['addBoard']);

// Composables imports
import {
    useScreenSize
} from '@/composables/globals';

// UseGlobalScope imports
import { useEmitter } from '@/composables/useEmitter';

const emitter = useEmitter();
// use global scope
const { t, locale } = useI18n();
const route = useRoute();
const router = useRouter();
const isDesktop = useScreenSize();

const showBoardModals = async (formName, buttonName) => {
    headerStore.setBoardFormName(buttonName);
}

</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap');
</style>
